// removed by extract-text-webpack-plugin
module.exports = {"container":"container__22gy-","defaultContainer":"defaultContainer__2-KLF"};


//////////////////
// WEBPACK FOOTER
// ./pages/currency/currencyCommon.scss
// module id = 490
// module chunks = 68